import { render, staticRenderFns } from "./Filebar.vue?vue&type=template&id=36209801&scoped=true"
import script from "./Filebar.vue?vue&type=script&lang=js"
export * from "./Filebar.vue?vue&type=script&lang=js"
import style0 from "./Filebar.vue?vue&type=style&index=0&id=36209801&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36209801",
  null
  
)

export default component.exports